module.exports = __webpack_public_path__ + "img/lung-cancer.c7fa787c.png";